import React, { Suspense, lazy } from 'react';
import Loader from 'wrapper/loader';

const Login = lazy(() => import('@/pages/shared/auth/login/Login'));
const TruvTestPage = lazy(() => import('@/pages/b2b/officer/test'));
const LoanInformation = lazy(() => import('@/pages/b2b/loan-management/loan-information'));
const NotFound = lazy(() => import('components/404'));
const BorrowerProfile = lazy(() => import('@/pages/b2b/loan-management/borrower-profile'));
const PipelineAdmin = lazy(() => import('@/pages/b2b/pipeline'));
const Dashboard = lazy(() => import('@/pages/b2b/dashboard'));
const Tools = lazy(() => import('@/pages/b2b/tools'));
const QuickPrice = lazy(() => import('@/pages/b2b/loan-management/quick-price'));
const HelpSupport = lazy(() => import('@/pages/shared/help-support'));
const CompanyOnboarding = lazy(() => import('@/pages/b2b/onboarding/CompanyOnboarding'));
const DocumentPage = lazy(() => import('@/components/document-viewer/DocumentPage'));

const suspenseFallback = <Loader />;

const officerRoutes = [
  {
    path: '/',
    element: (
      <Suspense fallback={suspenseFallback}>
        <Login />
      </Suspense>
    ),
    children: [
      {
        path: 'onboard',
        element: (
          <Suspense fallback={suspenseFallback}>
            <CompanyOnboarding />
          </Suspense>
        ),
      },
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={suspenseFallback}>
            <Dashboard />
          </Suspense>
        ),
        children: [],
      },
      {
        path: 'truv-test',
        element: (
          <Suspense fallback={suspenseFallback}>
            <TruvTestPage />
          </Suspense>
        ),
      },
      {
        path: 'loanInformation',
        element: (
          <Suspense fallback={suspenseFallback}>
            <LoanInformation />
          </Suspense>
        ),
        children: [],
      },
      {
        path: ':param/lead',
        element: (
          <Suspense fallback={suspenseFallback}>
            <BorrowerProfile />
          </Suspense>
        ),
      },
      {
        path: 'pipeline',
        element: (
          <Suspense fallback={suspenseFallback}>
            <PipelineAdmin />
          </Suspense>
        ),
      },
      {
        path: 'tools',
        element: (
          <Suspense fallback={suspenseFallback}>
            <Tools />
          </Suspense>
        ),
      },
      {
        path: 'quickPrice',
        element: (
          <Suspense fallback={suspenseFallback}>
            <QuickPrice />
          </Suspense>
        ),
      },
      {
        path: 'help-support',
        element: (
          <Suspense fallback={suspenseFallback}>
            <HelpSupport />
          </Suspense>
        ),
      },
      {
        // One document in a tab of its own, opened from the document viewer.
        // Login renders it without the app shell.
        path: 'document/:documentId',
        element: (
          <Suspense fallback={suspenseFallback}>
            <DocumentPage />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: (
          <Suspense fallback={suspenseFallback}>
            <NotFound />
          </Suspense>
        ),
      },
    ],
  },
];

export default officerRoutes;
